import { isPlainObject } from './isPlainObject';

const isNullish = (test: any) => test === undefined || test === null;
const isNullishOrEmpty = (test: any) =>
  isNullish(test) || (isPlainObject(test) && Object.keys(test).length === 0);

const skipNullishDeep = <T extends Record<string, any> = any>(
  obj: T,
  skipEmptyObject = true,
): Partial<T> => {
  if (!isPlainObject(obj)) {
    return obj;
  }

  const check = skipEmptyObject ? isNullishOrEmpty : isNullish;

  return Object.fromEntries(
    Object.entries(obj)
      .map(([key, value]) => {
        // skip only in plain object, ignore File, FormData and etc.
        if (isPlainObject(value)) {
          return [key, skipNullishDeep(value, skipEmptyObject)];
        }

        return [key, value];
      })
      .filter(([, value]) => !check(value)),
  ) as Partial<T>;
};

export { skipNullishDeep };
